import { DatePicker as DatePickerBase } from "@mui/x-date-pickers";

// A wrapper around mui datepicker, which handles backspace / delete keystrokes (or anything else that causes an invalid date) gracefully.
// It prevents calls to onChange() with invalid dates, which usually result in the app crashing.
const DatePicker: typeof DatePickerBase = ({ value, onChange, ...rest }) => {
  return <DatePickerBase
    value={value}
    onChange={onChange ? (newValue, context) => onChange(newValue && !Number.isNaN(newValue.getTime()) ? newValue : value || null, context) : undefined}
    {...rest}
  />
}

export default DatePicker;
